const types = {
    INTERACTION_VISIBILITY_HIDE_INTERACTIONS: 'INTERACTION_VISIBILITY_HIDE_INTERACTIONS',
    INTERACTION_VISIBILITY_SHOW_INTERACTIONS: 'INTERACTION_VISIBILITY_SHOW_INTERACTIONS',
    INTERACTION_VISIBILITY_TRANSACTION_DONE: 'INTERACTION_VISIBILITY_TRANSACTION_DONE',
};

const interactionVisibilityActions = {
    types,

    hideInteractionsInQuestion(questionId, mediaLogicalName, interactionVisibility) {
        return {
            type: types.INTERACTION_VISIBILITY_HIDE_INTERACTIONS,
            questionId,
            mediaLogicalName,
            interactionVisibility,
        };
    },

    showInteractionsInQuestion(questionId) {
        return {
            type: types.INTERACTION_VISIBILITY_SHOW_INTERACTIONS,
            questionId,
        };
    },

    setVisibilityTransactionDoneForQuestion(questionId) {
        return {
            type: types.INTERACTION_VISIBILITY_TRANSACTION_DONE,
            questionId,
        };
    },
};

export default interactionVisibilityActions;
